if (!customElements.get('popup-newsletter')) {
  customElements.define(
    'popup-newsletter',
    class PopupNewsletter extends ModalDialog {
      constructor() {
        super();
      }

      connectedCallback() {
        super.connectedCallback();

        this.storageKey = 'true_rest:popup_newsletter_shown_at';
        this.delaySeconds = Number(this.dataset.delaySeconds || 4);
        this.frequencyDays = Number(this.dataset.frequencyDays || 7);

        this.querySelector('form')?.addEventListener('submit', () => this.remember());

        // Skip the timed auto-show while a merchant is actively editing the
        // theme, so it doesn't keep popping up over their own edits.
        if (window.Shopify && window.Shopify.designMode) return;
        if (this.withinSuppressionWindow()) return;

        this.autoShowTimeout = window.setTimeout(() => this.show(this), this.delaySeconds * 1000);
      }

      withinSuppressionWindow() {
        const shownAt = Number(localStorage.getItem(this.storageKey) || 0);
        if (!shownAt) return false;
        const elapsedDays = (Date.now() - shownAt) / (1000 * 60 * 60 * 24);
        return elapsedDays < this.frequencyDays;
      }

      remember() {
        localStorage.setItem(this.storageKey, String(Date.now()));
      }

      show(opener) {
        super.show(opener);
        this.remember();
      }

      hide() {
        window.clearTimeout(this.autoShowTimeout);
        super.hide();
      }
    }
  );
}
